export const RUN_FETCH_IN_PROGRESS = "RUN_FETCH_IN_PROGRESS";
export const RUN_FETCH_SUCCESS = "RUN_FETCH_SUCCESS";
export const RUN_FETCH_ERROR = "RUN_FETCH_ERROR";
export const RUN_UPDATE_NUMBER = "RUN_UPDATE_NUMBER";
export const RUN_RESET = "RUN_RESET";
